import { convertToSentenceCase } from "../../utils";

export function getMinErrorMessage(fieldname: string | null, comparison: "greater" | "smaller", minValue: number) {
  const label = fieldname ? convertToSentenceCase(fieldname) : "This field";
  return `${label} must be ${comparison} than ${minValue}`;
}
